import React, { useState } from "react"
import Page from "../../common/page/Page"
import Form from "../../common/form/Form"
import LoginIcon from "../../icons/LoginIcon"
import { Link, useNavigate } from "react-router-dom"
import axios from "axios"
import Loader from "../../common/loader/Loader"
import styles from "../../common/form/form.module.css"

const ForgotPassword = () => {
  const navigator = useNavigate()
  const [isSend, setISSend] = useState(false)
  const [formData, setFormData] = useState({
    email: "",
  })
  const [error, setError] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  // const navigate = useNavigate()

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError("")

    if (!formData.email) {
      setError("Email is required.")
      return
    }

    try {
      setISSend(false)
      setIsLoading(true)
      const response = await axios.post("api/auth/forgot-password", {
        email: formData.email,
      })
      //   console.log("Forgot password request successful:", response.data)

      setFormData({
        email: "",
      })
      if (response.status === 200) {
        setISSend(true)
        setTimeout(() => {
          setError("Password reset link sent to your email.")
          navigator("/login")
        }, 3000)
      }
      setIsLoading(false)

      // Redirect to dashboard or home page
      // navigate("/dashboard")
    } catch (err) {
      setIsLoading(false)
      console.error("Forgot password error:", err)
      if (err.response) {
        setError(err.response.data.error || "Forgot password request failed.")
      } else {
        setError("Network error, please try again.")
      }
    }
  }

  return (
    <Page title={"Forgot Password"} searchDisabled={true}>
      {isSend ? (
        <div className={styles.cardContainer}>
          <div className={styles.successBanner}>
            Password reset link sent to your email. Please check your inbox.
          </div>
          <div className={styles.linkBox}>
            <p>
              <Link to={"/login"}>Back to Login</Link>
            </p>
          </div>
        </div>
      ) : isLoading ? (
        <div style={{ display: "flex", height: "calc(80vh - 100px)" }}>
          <Loader />
        </div>
      ) : (
        <Form onSubmit={handleSubmit}>
          <div className={styles.cardContainer}>
            <div className={styles.cardHeader}>
              <h2>Forgot Password</h2>
              <p>Enter your email to receive a password reset link</p>
              <div className={styles.quote}>
                "Peace of mind starts with simple, mindful care."
              </div>
            </div>

            <div>
              <label htmlFor="login_email">Email Address</label>
              <input
                type="email"
                id="login_email"
                name="email"
                placeholder="name@example.com"
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            {error && <div className={styles.errorBanner}>{error}</div>}

            <div>
              <button type="submit">
                Send Reset Link <LoginIcon />
              </button>
            </div>

            <div className={styles.linkBox}>
              <p>
                <Link to={"/login"}>Back to Login</Link>
              </p>
              <p>
                Don't have an account? <Link to={"/sign-up"}>Create Account</Link>
              </p>
            </div>
          </div>
        </Form>
      )}
    </Page>
  )
}

export default ForgotPassword
